import JwtToken from '../services/jwt-token';

export default {
  autenticacaoUsuario (context, {user, password}) {
    return JwtToken.accessToken(user, password).then((response) => {
        if (response.status === 201 || response.status === 200) {
            context.commit('SET_USERTOKEN', response.data)
        }
    })
  },
  logout (context) {
      return new Promise((resolve) => {
          JwtToken.logout()
          return resolve({})
      })
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js